import type LoginError from './exceptions/loginError';
import type {
	ResetPassword,
	ResetPasswordError
} from './exceptions/resetPasswordError';

enum UserRole {
	Admin = 'Admin',
	VA = 'VA',
	Manager = 'Manager',
	User = 'User',
	Free = 'Free-Tier',
	PreTrial = 'Pre-Trial'
}

type Company = {
	name: string;
};
// FIXME: update this interface
export interface User {
	id?: string;
	accessToken?: string;
	refreshToken?: string;
	otpStateToken?: string;
	email: string;
	password?: string;
	name?: string;
	role?: UserRole;
	company?: Company;
	emailLimit?: number;
	emailLimitLeft?: number;
	maxEmailLimit?: number;
	login_count?: number;
	emailKey?: string;
	emailValid?: boolean;
	emailRequested?: boolean;
	facebookFreemium?: boolean;
	emailVerified?: boolean;
	re2Email?: string;
	threadedEmail?: {
		nylasEnabled?: boolean;
	};
	crmBcc?: Record<string, string>;
	features?: Record<string, unknown>;
	re2SharedDomain?: boolean;
	createdAt?: Date;
	timeZone?: Date;
	nylasSyncStatus?: string;
}

enum UserActionTypes {
	USER_LOGIN_REQUEST = 'user/USER_LOGIN_REQUEST',
	USER_LOGIN_SUCCESS = 'user/USER_LOGIN_SUCCESS',
	USER_LOGIN_FAILURE = 'user/USER_LOGIN_FAILURE',

	USER_LOGOUT_REQUEST_API = 'user/USER_LOGOUT_REQUEST_API',

	USER_LOGOUT_REQUEST = 'user/USER_LOGOUT_REQUEST',
	USER_LOGOUT_SUCCESS = 'user/USER_LOGOUT_SUCCESS',
	USER_LOGOUT_FAILURE = 'user/USER_LOGOUT_FAILURE',

	USER_REFRESH_TOKEN_REQUEST = 'user/USER_REFRESH_TOKEN_REQUEST',
	USER_REFRESH_TOKEN_SUCCESS = 'user/USER_REFRESH_TOKEN_SUCCESS',
	USER_REFRESH_TOKEN_EXPIRED_FAILURE = 'user/USER_REFRESH_TOKEN_EXPIRED_FAILURE',

	USER_REFRESH_TOKEN_REQUEST_API = 'user/USER_REFRESH_TOKEN_REQUEST_API',
	USER_REFRESH_TOKEN_SUCCESS_API = 'user/USER_REFRESH_TOKEN_SUCCESS_API',

	USER_GET_USER_REQUEST = 'user/USER_GET_USER_REQUEST',
	USER_GET_USER_SUCCESS = 'user/USER_GET_USER_SUCCESS',
	USER_GET_USER_FAILURE = 'user/USER_GET_USER_FAILURE',

	USER_GET_USER_BY_EMAIL_REQUEST = 'user/USER_GET_USER_BY_EMAIL_REQUEST',
	USER_GET_USER_BY_EMAIL_SUCCESS = 'user/USER_GET_USER_BY_EMAIL_SUCCESS',
	USER_GET_USER_BY_EMAIL_FAILURE = 'user/USER_GET_USER_BY_EMAIL_FAILURE',
	USER_GET_USER_BY_EMAIL_NO_USER = 'user/USER_GET_USER_BY_EMAIL_NO_USER',

	USER_GET_USERS_REQUEST = 'user/USER_GET_USERS_REQUEST',
	USER_GET_USERS_SUCCESS = 'user/USER_GET_USERS_SUCCESS',
	USER_GET_USERS_FAILURE = 'user/USER_GET_USERS_FAILURE',

	USER_VALIDATE_EMAIL_REQUEST = 'user/USER_VALIDATE_EMAIL_REQUEST',
	USER_VALIDATE_EMAIL_SUCCESS = 'user/USER_VALIDATE_EMAIL_SUCCESS',
	USER_VALIDATE_EMAIL_FAILURE = 'user/USER_VALIDATE_EMAIL_FAILURE',

	USER_RESET_PASSWORD_REQUEST = 'user/USER_RESET_PASSWORD_REQUEST',
	USER_RESET_PASSWORD_SUCCESS = 'user/USER_RESET_PASSWORD_SUCCESS',
	USER_RESET_PASSWORD_FAILURE = 'user/USER_RESET_PASSWORD_FAILURE',

	USER_ADMIN_RESET_PASSWORD_REQUEST = 'user/USER_ADMIN_RESET_PASSWORD_REQUEST',
	USER_ADMIN_RESET_PASSWORD_SUCCESS = 'user/USER_ADMIN_RESET_PASSWORD_SUCCESS',
	USER_ADMIN_RESET_PASSWORD_FAILURE = 'user/USER_ADMIN_RESET_PASSWORD_FAILURE',

	USER_ADMIN_CHANGE_RELAY_REQUEST = 'user/USER_ADMIN_CHANGE_RELAY_REQUEST',
	USER_ADMIN_CHANGE_RELAY_SUCCESS = 'user/USER_ADMIN_CHANGE_RELAY_SUCCESS',
	USER_ADMIN_CHANGE_RELAY_FAILURE = 'user/USER_ADMIN_CHANGE_RELAY_FAILURE',

	USER_UPDATE_EMAILS_LEFT = 'user/USER_UPDATE_EMAILS_LEFT',
	USER_UPDATE_EMAILS_LEFT_LOCAL = 'user/USER_UPDATE_EMAILS_LEFT_LOCAL',
	USER_INCREASE_EMAILS_LEFT = 'user/USER_INCREASE_EMAILS_LEFT',

	USER_UPDATE_EMAILS_LIMIT_REQUEST = 'user/USER_UPDATE_EMAILS_LIMIT_REQUEST',
	USER_UPDATE_EMAILS_LIMIT_SUCCESS = 'user/USER_UPDATE_EMAILS_LIMIT_SUCCESS',
	USER_UPDATE_EMAILS_LIMIT_FAILURE = 'user/USER_UPDATE_EMAILS_LIMIT_FAILURE',

	USER_UPDATE_USER_ADMIN_REQUEST = 'user/USER_UPDATE_USER_ADMIN_REQUEST',
	USER_UPDATE_USER_ADMIN_SUCCESS = 'user/USER_UPDATE_USER_ADMIN_SUCCESS',
	USER_UPDATE_USER_ADMIN_FAILURE = 'user/USER_UPDATE_USER_ADMIN_FAILURE',

	USER_ADD_EMAIL_TOKEN = 'user/USER_ADD_EMAIL_TOKEN',
	USER_ADD_EMAIL_TOKEN_SUCCESS = 'user/USER_ADD_EMAIL_TOKEN_SUCCESS',
	USER_ADD_EMAIL_TOKEN_FAILURE = 'user/USER_ADD_EMAIL_TOKEN_FAILURE',

	USER_UPDATE_SUBSCRIPTION = 'user/USER_UPDATE_SUBSCRIPTION',

	USER_TOGGLE_ADD_USER_MODAL = 'user/USER_TOGGLE_ADD_USER_MODAL',
	USER_ADD_NEW_USER_REQUEST = 'user/USER_ADD_NEW_USER_REQUEST',
	USER_ADD_NEW_USER_LOADING = 'user/USER_ADD_NEW_USER_LOADING',
	USER_ADD_NEW_USER_SUCCESS = 'user/USER_ADD_NEW_USER_SUCCESS',

	USER_DELETE_USER_REQUEST = 'user/USER_DELETE_USER_REQUEST',
	USER_DELETE_USER_SUCCESS = 'user/USER_DELETE_USER_SUCCESS',

	USER_TOGGLE_ADD_BCC_MODAL = 'user/USER_TOGGLE_ADD_BCC_MODAL',
	USER_ADD_NEW_BCC_REQUEST = 'user/USER_ADD_NEW_BCC_REQUEST',
	USER_ADD_NEW_BCC_LOADING = 'user/USER_ADD_NEW_BCC_LOADING',
	USER_ADD_NEW_BCC_SUCCESS = 'user/USER_ADD_NEW_BCC_SUCCESS',
	USER_ADD_NEW_BCC_FAILURE = 'user/USER_ADD_NEW_BCC_FAILURE',
	USER_ADD_NEW_BCC_SUCCESS_OFF = 'user/USER_ADD_NEW_BCC_SUCCESS_OFF',

	USER_DELETE_BCC_REQUEST = 'user/USER_DELETE_BCC_REQUEST',

	USER_CREATE_SCHEDULE_REQUEST = 'user/USER_CREATE_SCHEDULE_REQUESTS',
	USER_CREATE_SCHEDULE_SUCCESS = 'user/USER_CREATE_SCHEDULE_SUCCESS',
	USER_CREATE_SCHEDULE_CAL_AUTH = 'user/USER_CREATE_SCHEDULE_CAL_AUTH',

	USER_ADMIN_ACCESS_ACCOUNT_REQUEST = 'user/USER_ADMIN_ACCESS_ACCOUNT_REQUEST',
	USER_ADMIN_ACCESS_ACCOUNT_FAILURE = 'user/USER_ADMIN_ACCESS_ACCOUNT_FAILURE',
	USER_ADMIN_ACCESS_ACCOUNT_CLEAR_STATUS = 'user/USER_ADMIN_ACCESS_ACCOUNT_CLEAR_STATUS',

	USER_GET_NEW_COMMUNICATIONS = 'user/USER_GET_NEW_COMMUNICATIONS',
	USER_GET_NEW_COMMUNICATIONS_SUCCESS = 'user/USER_GET_NEW_COMMUNICATIONS_SUCCESS',

	USER_GET_NOTIFICATIONS = 'user/USER_GET_NOTIFICATIONS',
	USER_GET_NOTIFICATIONS_SUCCESS = 'user/USER_GET_NOTIFICATIONS_SUCCESS',
	USER_POST_NOTIFICATIONS_READ = 'user/USER_POST_NOTIFICATIONS_READ',
	USER_CHECK_USER_EXISTS = 'user/USER_CHECK_USER_EXISTS',
	USER_CHECK_USER_EXISTS_SUCCESS = 'USER_CHECK_USER_EXISTS_SUCCESS',
	USER_SIGN_UP_FACEBOOK_FREEMIUM = 'USER_SIGN_UP_FACEBOOK_FREEMIUM',
	USER_VERIFY_SIGNUP_TOKEN = 'USER_VERIFY_SIGNUP_TOKEN',
	USER_VERIFY_EXISTING_USER_SIGNUP_TOKEN = 'USER_VERIFY_EXISTING_USER_SIGNUP_TOKEN',
	USER_ADD_HOSTED_EMAIL = 'USER_ADD_HOSTED_EMAIL',
	USER_ADD_SIMPLE_HOSTED_EMAIL = 'USER_ADD_SIMPLE_HOSTED_EMAIL',

	USER_GET_COMPANIES_REQUEST = 'USER_GET_COMPANIES_REQUEST',
	USER_GET_COMPANIES_SUCCESS = 'USER_GET_COMPANIES_SUCCESS',
	USER_GET_COMPANIES_FAILURE = 'USER_GET_COMPANIES_FAILURE',

	USER_ADMIN_CREATE_ACCOUNTS_REQUEST = 'USER_ADMIN_CREATE_ACCOUNTS_REQUEST',
	USER_ADMIN_CREATE_ACCOUNTS_SUCCESS = 'USER_ADMIN_CREATE_ACCOUNTS_SUCCESS',
	USER_ADMIN_CREATE_ACCOUNTS_FAILURE = 'USER_ADMIN_CREATE_ACCOUNTS_FAILURE',

	USER_GENERATE_OTP_SECRET = 'user/USER_GENERATE_OTP_SECRET',
	USER_GENERATE_OTP_SECRET_SUCCESS = 'user/USER_GENERATE_OTP_SECRET_SUCCESS',
	USER_GENERATE_OTP_SECRET_FAILURE = 'user/USER_GENERATE_OTP_SECRET_FAILURE',

	USER_ENABLE_OTP = 'user/USER_ENABLE_OTP',
	USER_ENABLE_OTP_SUCCESS = 'user/USER_ENABLE_OTP_SUCCESS',
	USER_ENABLE_OTP_FAILURE = 'user/USER_ENABLE_OTP_FAILURE',

	USER_DEACTIVATE_OTP = 'user/USER_DEACTIVATE_OTP',
	USER_DEACTIVATE_OTP_SUCCESS = 'user/USER_DEACTIVATE_OTP_SUCCESS',
	USER_DEACTIVATE_OTP_FAILURE = 'user/USER_DEACTIVATE_OTP_FAILURE',

	USER_CLEAR_OTP_SUCCESS_FAILURE_STATES = 'user/USER_CLEAR_OTP_SUCCESS_FAILURE_STATES',
	USER_CLEAR_OTP_STATE = 'user/USER_CLEAR_OTP_STATE',

	USER_ADD_OTP_STATE_TOKEN = 'user/USER_ADD_OTP_STATE_TOKEN',

	USER_VERIFY_OTP = 'user/USER_VERIFY_OTP',
	USER_VERIFY_OTP_FAILURE = 'user/USER_VERIFY_OTP_FAILURE',

	USER_RESET_OTP = 'user/USER_RESET_OTP',
	USER_RESET_OTP_FAILURE = 'user/USER_RESET_OTP_FAILURE',

	USER_UPDATE_EMAIL_SENDING_METHOD = 'user/USER_UPDATE_EMAIL_SENDING_METHOD',

	USER_UPDATE_USER_ACTIVE_STATUS = 'user/USER_UPDATE_USER_ACTIVE_STATUS'
}

interface UserAction {
	type: UserActionTypes;
	payload?: any;
	error?: LoginError | ResetPasswordError | Error;
}

export { User as UserInterface, UserRole, UserAction, UserActionTypes };
